import { useUnload } from './use-unload';

const useFormUnload = (func) => {
  useUnload(() => {
    func?.();
  });
};

export { useFormUnload };
